import { Row } from '../components/main/spreading/models/models';

export class SpreadingMapTemplates {
    incomeStatementTmpl: Array<Row>;
    balanceSheetTmpl: Array<Row>;
    cashFlowStatementTmpl: Array<Row>;
}
